import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpService } from './services/http.service';
import { ErrorsService } from './services/errors.service';
import { HttpModule, XHRBackend, RequestOptions } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { ExportExcelService } from './services/export-excel.service';
import { KeysPipe } from './filter/pipe';
import { PasswordStrengthBar } from './component/passwordStrength';
import { PreloaderService } from './services/preloader.service';
import { ConfigService } from './services/config.service';

export function httpServiceFactory(backend: XHRBackend, defaultOptions: RequestOptions) {
  return new HttpService(backend, defaultOptions);
}

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    FormsModule
  ],
  providers: [
    HttpService,
    ErrorsService,
    ExportExcelService,
    {
      provide: HttpService,
      useFactory: httpServiceFactory,
      deps: [XHRBackend, RequestOptions]
    },
    PreloaderService,
    ConfigService
  ],
  declarations: [KeysPipe, PasswordStrengthBar],
  exports: [KeysPipe, PasswordStrengthBar]
})
export class UtilsModule { }



// WEBPACK FOOTER //
// ./src/app/utils/utils.module.ts